import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const bookingFileCreateMutationAtom = createMutationAtomFactory(
  'trade.bookingFileCreate',
  (params: {
    bookingId: string;
    fileName: string;
    fileSize: number;
    mimeType: string;
    public?: boolean;
  }) => ({
    tradeBookingFileCreate: {
      __args: {
        bookingId: params.bookingId,
        input: {
          fileName: params.fileName,
          fileSize: params.fileSize,
          mimeType: params.mimeType,
          public: params.public ?? false,
        },
      },
      file: {
        id: true,
        fileName: true,
        fileSize: true,
        mimeType: true,
        status: true,
      },
      uploadUrl: true,
    },
  }),
);
